export interface TimezoneOption {
    value: string;
    label: string;
}

export const timezoneOptions: TimezoneOption[] = [
    { value: "America/Anchorage", label: "Alaska" },
    { value: "America/Honolulu", label: "Hawaii" },
    { value: "America/Los_Angeles", label: "Pacific" },
    { value: "America/Denver", label: "Mountain" },
    { value: "America/Phoenix", label: "Mountain (no DST)" },
    { value: "America/Chicago", label: "Central" },
    { value: "America/New_York", label: "Eastern" },
    { value: "America/Vancouver", label: "Pacific (Canada)" },
    { value: "America/Edmonton", label: "Mountain (Canada)" },
    { value: "America/Halifax", label: "Atlantic (Canada)" },
    { value: "America/Winnipeg", label: "Central (Canada)" },
    { value: "America/Toronto", label: "Eastern (Canada)" },
    { value: "America/St_Johns", label: "Newfoundland (Canada)" },
];

export const timezoneOptionsIncluding = (current: string): TimezoneOption[] =>
    timezoneOptions.some(option => option.value === current)
        ? timezoneOptions
        : [{ value: current, label: current.replace(/_/g, " ") }, ...timezoneOptions];
